import _classCallCheck from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { LineSegments2 } from './LineSegments2.js';
import { LineGeometry } from './LineGeometry.js';
import { LineMaterial } from './LineMaterial.js';

var Line2 = /*#__PURE__*/function (_LineSegments) {
  _inherits(Line2, _LineSegments);

  var _super = _createSuper(Line2);

  function Line2() {
    var _this;

    var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new LineGeometry();
    var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new LineMaterial({
      color: Math.random() * 0xffffff
    });

    _classCallCheck(this, Line2);

    _this = _super.call(this, geometry, material);

    _defineProperty(_assertThisInitialized(_this), "type", 'Line2');

    _defineProperty(_assertThisInitialized(_this), "isLine2", true);

    return _this;
  }

  return Line2;
}(LineSegments2);

export { Line2 };